import React from 'react';
import { NavLink } from 'react-router-dom';

import './NavLinks.css';

const NavLinks = props => {

  return (
    <ul className="nav-links">
 
      <li>
       <a href="/#Portfolio">
         Leistungen
       </a>
      </li>
      <li>
       <a href="/#About">
         Über uns
       </a>
      </li>
      <li>
       <a href="/#Vehicles">
         Fahrzeuge
       </a>
      </li>

      <li>
        <NavLink to="/contact" exact>
       Kontakt
        </NavLink>
      </li>
      
      <li>
        <NavLink to="/impressum" exact>
        Impressum
        </NavLink>
      </li>
     
    </ul>
  );
};

export default NavLinks;
